import React from 'react';
import { BrowserRouter, Routes, Route, useParams } from 'react-router-dom';
import PageMeta from '../../components/PageMeta/PageMeta';
import Services from '../../api/Services';
import Homepage from '../HomePage/HomePage';
import AboutPage from '../AboutPage/AboutPage';
import TrackingPage from '../TrackingPage/TrackingPage';
import ServicePages from '../ServicePage/ServicePage';
import ServiceSinglePage from '../ServiceSinglePage/ServiceSinglePage';
import ContactPage from '../ContactPage/ContactPage';

const RouteWithMeta = ({ component: Component, title, description, keywords, image, canonicalPath }) => (
  <PageMeta
    title={title}
    description={description}
    keywords={keywords}
    image={image}
    canonicalPath={canonicalPath}
  >
    <Component />
  </PageMeta>
);

const slugToTitle = (slug = '') =>
  slug
    .replace(/[-_]+/g, ' ')
    .replace(/\b\w/g, (character) => character.toUpperCase())
    .trim();

const SlugRouteWithMeta = ({
  component: Component,
  description,
  keywords,
  image,
  canonicalBase,
  lookup,
}) => {
  const { slug } = useParams();
  const resolvedItem = lookup ? lookup(slug) : null;
  const resolvedTitle = resolvedItem?.title || slugToTitle(slug);
  const pageTitle = resolvedTitle ? `${resolvedTitle} | Ferry Gold Shipping` : 'Ferry Gold Shipping';
  const pageDescription =
    description ||
    resolvedItem?.description ||
    `Read more about ${resolvedTitle || 'this page'} at Ferry Gold Shipping.`;
  const canonicalPath = canonicalBase && slug ? `${canonicalBase}/${slug}` : canonicalBase;

  return (
    <PageMeta
      title={pageTitle}
      description={pageDescription}
      keywords={keywords}
      image={image}
      canonicalPath={canonicalPath}
    >
      <Component />
    </PageMeta>
  );
};

const findServiceBySlug = (slug) => Services.find((service) => service.slug === slug);

const AllRoute = () => {
  return (
    <div className='App'>
      <BrowserRouter>
        <Routes>
          <Route
            path='/'
            element={
              <RouteWithMeta
                component={Homepage}
                title='International Shipping and Freight Solutions'
                description='Track shipments and explore Ferry Gold Shipping services for road freight, air freight, ocean freight, and warehousing.'
                canonicalPath='/'
              />
            }
          />
          <Route
            path='about'
            element={
              <RouteWithMeta
                component={AboutPage}
                title='About Us'
                description='Learn about Ferry Gold Shipping, our logistics approach, and the team behind our freight operations.'
                canonicalPath='/about'
              />
            }
          />
          <Route
            path='tracking'
            element={
              <RouteWithMeta
                component={TrackingPage}
                title='Shipment Tracking'
                description='Track shipment status, milestones, and route updates for your freight movement.'
                canonicalPath='/tracking'
              />
            }
          />
          <Route
            path='services'
            element={
              <RouteWithMeta
                component={ServicePages}
                title='Services'
                description='Explore road freight, air freight, ocean freight, and warehousing solutions.'
                canonicalPath='/services'
              />
            }
          />
          <Route
            path='services/:slug'
            element={
              <SlugRouteWithMeta
                component={ServiceSinglePage}
                canonicalBase='/services'
                lookup={findServiceBySlug}
              />
            }
          />
          <Route
            path='contact'
            element={
              <RouteWithMeta
                component={ContactPage}
                title='Contact'
                description='Contact Ferry Gold Shipping for freight, warehousing, and shipment support.'
                canonicalPath='/contact'
              />
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default AllRoute;
